var React = require('react');

function Figma (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M277 170.7A85.35 85.35 0 0 0 277 0H106.3a85.3 85.3 0 0 0 0 170.6 85.35 85.35 0 0 0 0 170.7 85.35 85.35 0 1 0 85.3 85.4v-256zm0 0a85.3 85.3 0 1 0 85.3 85.3 85.31 85.31 0 0 0-85.3-85.3z"}));
}

Figma.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Figma;

Figma.default = Figma;
